export const isIOS = (): boolean => {
  const uaData = (navigator as any).userAgentData;
  const ua = navigator.userAgent || '';

  // userAgentData when available
  if (uaData?.platform) {
    const platform = uaData.platform.toLowerCase();
    if (platform.includes('iphone') || platform.includes('ipad') || platform.includes('ipod')) {
      return true;
    }
  }

  // Fallback for older browsers / Safari
  if (/iPad|iPhone|iPod/i.test(ua)) {
    return true;
  }

  // iPad on iOS 13+ ( Mac but has touch)
  if (ua.includes('Mac') && 'ontouchend' in document) {
    return true;
  }

  return false;
};
